/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

/**
 * Extract a unique gondola ID from an AEM _path.
 * Uses last 3 segments to ensure uniqueness across event days.
 * e.g. "/content/dam/ews/ewsr/connect/2026/cx-days/gondolas/serverless-apps"
 *   → "cx-days/gondolas/serverless-apps"
 */
export const getGondolaId = (path) => {
  if (!path) return ''
  const segments = path.split('/').filter(Boolean)
  return segments.slice(-3).join('/')
}

/**
 * Get the URL slug for a gondola, unique even when titles are identical.
 * Appends the schedule date (e.g. "24-06") to disambiguate same-title sessions on different days.
 * e.g. "health-metrics-ki-24-06" vs "health-metrics-ki-25-06"
 */
export const getGondolaSlug = (gondola) => {
  const base = createSlug(gondola?.title ?? '')
  const date = gondola?.schedule?.date
  if (!date) return base
  const [, month, day] = date.split('-')
  return `${base}-${day}-${month}`
}

export const createSlug = (text) => {
  return text
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const findBySlug = (items, slug, titleField = 'title') => {
  return items.find(item => createSlug(item[titleField]) === slug);
};

/**
 * Find a gondola by its date-aware slug.
 */
export const findByGondolaSlug = (gondolas, slug) => {
  return gondolas.find(g => getGondolaSlug(g) === slug);
};

// CommonJS export for tests
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { createSlug, findBySlug, getGondolaId, getGondolaSlug, findByGondolaSlug };
}

